import React from 'react';
import NewPage from '../components/NewPage';
import WifiStatusContainer from '../containers/WifiStatusContainer';
import WifiContextProvider from '../modules/wifi';

const WifiPage = () => {
  return (
    <NewPage title="Wi-Fi 설정">
      <WifiContextProvider>
        <WifiStatusContainer />
      </WifiContextProvider>
    </NewPage>
  );
};

export default WifiPage;
